<template>
  <main-page fillBackground color="white">
    <div class="login-box" v-if="!showResetRequest && !showReset">
      <form
        @submit.prevent="login"
        name="form"
        class="d-flex flex-column justify-content-between"
      >
        <div
          class="si-text-black si-font"
          style="font-size: 48px; margin-top: -24px; margin-bottom: 16px"
        >
          Login
        </div>
        <div class="form-group">
          <label class="text-lg si-font si-text-black">Username</label>
          <input
            type="text"
            class="login-input"
            placeholder="Email"
            required
            v-model.trim="username"
          />
        </div>
        <div class="form-group">
          <label class="text-lg si-font si-text-black">Password</label>
          <input
            type="password"
            class="login-input"
            placeholder="Password"
            required
            v-model.trim="password"
          />
        </div>
        <button class="btn btn-si-blue" type="submit">Log In</button>
        <a class="btn btn-si-orange mt-2" href="#/signup">Create New Account</a>

        <a
          href="/v1/auth?provider=g_student"
          class="my-3 google-button"
          @click="goingToGoogle = true"
        >
          <img style="width: 280px" src="@/assets/images/google_sign_in.png" />
          <div class="google-button-overlay">
            <div v-if="goingToGoogle" class="loading-overlay">
              <loading type="medium" />
            </div>
          </div>
        </a>
        <a
          @click="showResetRequest = true"
          id="cancelResetRequest"
          class="btn clickable"
          style="color: gray"
        >
          <i class="fas fa-lock m-r-5"></i> Forgot password?
        </a>
        <div
          class="mt-4 d-flex flex-row justify-content-between w-100"
          style="opacity: 0.8"
        >
          <a
            class="_600 text-white-dk mt-2 ml-4 clickable"
            href="./docs/STEM_Innovator_TC.pdf"
            target="_blank"
            >Terms of Use</a
          >

          <a
            class="_600 text-white-dk mt-2 mr-4 clickable"
            href="./docs/STEM_Innovator_Privacy_Policy.pdf"
            target="_blank"
            >Privacy Policy</a
          >
        </div>
      </form>
    </div>
    <div>
      <div
        class="login-box d-flex flex-column justify-content-between"
        v-if="showResetRequest"
      >
        <form
          class="form-horizontal form-material"
          id="loginform"
          action="index.html"
          @submit.prevent="resetPassword()"
        >
          <h3
            class="si-text-black si-font"
            style="font-size: 32px; margin-bottom: 16px"
          >
            Password Reset
          </h3>
          <div class="form-group">
            <div class="col-xs-12">
              <input
                id="resetEmail"
                class="form-control"
                type="text"
                required
                placeholder="Email Address"
                v-model="resetEmail"
              />
            </div>
          </div>

          <div class="form-group text-center">
            <div class="col-xs-12 p-b-20">
              <button
                class="btn btn-block btn-info"
                type="submit"
                :disabled="inProgress"
              >
                Send Reset Email
                <loading v-if="inProgress" type="icon" class="ml-1" />
              </button>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <div class="d-flex no-block align-items-center">
                <div class="ml-auto">
                  <a
                    @click="showResetRequest = false"
                    id="showResetRequest"
                    class="clickable"
                    style="color: gray"
                  >
                    <i class="fas fa-times m-r-5" style="color: gray"></i>
                    Cancel
                  </a>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" v-if="err">
                <div class="d-flex no-block align-items-center">
                  <p class="text-danger">{{ err.message }}</p>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div
        class="login-box d-flex flex-column justify-content-between"
        v-if="showReset"
      >
        <form
          class="form-horizontal form-material"
          id="loginform"
          action="index.html"
          @submit.prevent="changePassword()"
        >
          <h3
            class="si-text-black si-font"
            style="font-size: 32px; margin-bottom: 16px"
          >
            Password Reset
          </h3>
          <div class="form-group">
            <div class="col-xs-12">
              <input
                id="resetEmail"
                class="form-control"
                type="password"
                required
                placeholder="New Password"
                v-model.trim="newPassword1"
              />
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-12">
              <input
                id="resetEmail"
                class="form-control"
                type="password"
                required
                placeholder="Confirm New Password"
                v-model.trim="newPassword2"
              />
            </div>
          </div>

          <div class="ml-2" style="min-height: 23px; max-width: 200px">
            <div
              v-for="(error, i) in passwordErrors()"
              :key="i"
              class="text-danger"
            >
              <i class="fas fa-exclamation-triangle mr-1" />
              {{ error }}
            </div>
          </div>

          <div class="form-group text-center">
            <div class="col-xs-12 p-b-20">
              <button class="btn btn-block btn-info" :disabled="inProgress">
                Change Password
                <loading v-if="inProgress" type="icon" class="ml-1" />
              </button>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <div class="d-flex no-block align-items-center">
                <div class="ml-auto">
                  <a
                    @click="showReset = false"
                    id="cancelReset"
                    class="clickable"
                    style="color: gray"
                  >
                    <i class="fas fa-times m-r-5" style="color: gray"></i>
                    Cancel
                  </a>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" v-if="err">
                <div class="d-flex no-block align-items-center">
                  <p class="text-danger">{{ err.message }}</p>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AuthService from "@/services/AuthService";
import AdminService from "@/services/AdminService";
import BrandService from "@/services/BrandService";
import Notie from "@/services/NotieService";

export default {
  name: "Home",

  props: [],

  components: { MainPage },

  data() {
    return {
      brand: BrandService.getBrand(),

      username: "",
      password: "",

      goingToGoogle: false,

      user: null,

      showResetRequest: false,
      resetEmail: "",

      showReset: false,
      resetToken: null,
      resetUsername: null,
      newPassword1: "",
      newPassword2: "",
    };
  },

  created() {
    this.resetToken = this.$route.query.token;
    if (this.resetToken) {
      this.showReset = true;
    }
  },

  methods: {
    login() {
      AuthService.login(this.username, this.password)
        .then((resp) => {
          // Successful login, but with redirect message
          if (resp.data) {
            if (resp.data.message == "toDistrictPick") {
              this.$router.push("/district_select");
            } else {
              Notie.error("Unexpected login error");
              console.log("UNEXPECTED LOGIN MESSAGE", resp);
            }
            return;
          }

          // Successful normal login
          let user = resp.user;
          let hash = resp.hash;

          AdminService.getDistrict(user.district_id)
            .then((r) => {
              var path = window.location.origin;
              if (r.data.host) {
                path = r.data.host;
              }

              console.log("LOGIN USER", user);
              if (user.role == "ADMIN") {
                path = path + "/#/admin";
              } else if (user.role == "TEACHER") {
                path = path + "/#/classes";
              } else if (user.role == "JUDGE") {
                if (user.sections && user.sections.length > 1) {
                  path = path + "/#/classes";
                } else {
                  path = path + "/#/pitches";
                }
              } else {
                if (user.sections && user.sections.length == 1) {
                  path = path + "/#/portfolio";
                } else {
                  path = path + "/#/classes";
                }
              }

              if (hash) {
                path = path + "?hash=" + hash;
              }

              console.log("Post login going to path: " + path)
              
              window.location.href = path;
            })
            .catch((e) => {
              Notie.error("Could not retrieve district");
              console.log(e);
            });
        })
        .catch((e) => {
          if(e.response && e.response.data && e.response.data.data && e.response.data.data.includes("account is disabled")) {
            let role = e.response.data.data.split(" ")[0];
            Notie.error("Account Disabled", this.disabledMsg(role), 10);
          } else {
            Notie.error(
              "Unauthorized",
              "Please check your username and password"
            );
          }
        });
    },

    disabledMsg(role) {
      switch (role) {
        case "JUDGE":
        case "STUDENT":
        case "PARTNER":
          return "This account has expired. Please contact stem-innovator@uiowa.edu if you would like to request it be re-activated.";
        default:
          return "Contact stem-innovator@uiowa.edu to renew your license";
      }
    },

    resetPassword() {
      this.inProgress = true;
      AuthService.resetPassword(this.resetEmail)
        .then(() => {
          this.inProgress = false;
          Notie.success(
            this.resetEmail,
            `<p>Reset email sent!</p><p class="text-xs">Follow the link in your email to reset your password`
          );
          this.showResetRequest = false;
        })
        .catch((e) => {
          this.inProgress = false;
          console.log(e);
          Notie.error("Failed to reset password", e);
        });
    },

    changePassword() {
      if (!this.resetToken) {
        Notie.error("Password reset failed", "Invalid operation");
        return;
      }

      this.inProgress = true;
      if (this.passwordErrors().length == 0) {
        AuthService.setNewPassword(this.resetToken, this.newPassword1)
          .then(() => {
            this.inProgress = false;
            Notie.success(
              "Password Reset!",
              `You can use your new password to log in`
            );
            this.showReset = false;
          })
          .catch((e) => {
            this.inProgress = false;
            console.log(e);
            Notie.error("Failed to save new password", e);
          });
      } else {
        Notie.error("Failed to set password", 0);
      }
    },
    checkValidPassword() {
      this.passwordErrors = this.getPasswordErrors();
      this.canSetPassword =
        this.passwordErrors.length == 0 &&
        this.newPassword1 &&
        this.newPassword2;
    },

    checkPasswordLen(pass) {
      if (!pass) {
        return true;
      }
      return pass.length >= 8 && pass.length <= 16;
    },

    checkPasswordChars(pass) {
      if (!pass) {
        return true;
      }
      return (
        pass.match(/.*[A-Z].*/) &&
        pass.match(/.*[a-z].*/) &&
        pass.match(/.*[0-9].*/)
      );
    },

    checkPassword(pass) {
      return this.checkPasswordLen(pass) && this.checkPasswordChars(pass);
    },

    checkMatch(pass1, pass2) {
      if (pass1 && pass2) {
        if (pass1 != pass2) {
          return false;
        }
      }
      return true;
    },

    passwordErrors() {
      var errs = [];
      if (!this.checkPasswordChars(this.newPassword1)) {
        errs.push(
          "Must include at least one lowercase (a-z), at least one uppercase (A-Z), and at least one digit (0-9)"
        );
      }
      if (!this.checkPasswordLen(this.newPassword1)) {
        errs.push("Password must be between 8 and 16 characters");
      }
      if (!this.checkMatch(this.newPassword1, this.newPassword2)) {
        errs.push("Passwords must match");
      }
      return errs;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  margin-bottom: 0;
}

.login-box {
  max-width: 392.5px;
  position: relative;
  top: calc((100% - 700px) / 2);
  left: 30%;
  border: 6px solid rgb(60, 60, 60);
  background-color: rgba(255, 205, 0, 0.7);
  padding: 2rem 2rem;
  backdrop-filter: blur(100px) brightness(130%);
}

@media screen and (max-width: 561px) {
  .login-box {
    left: calc((100% - 392.5px) / 2);
  }
}

@media screen and (max-height: 850px) {
  .login-box {
    top: 0px;
  }
}

.login-input {
  background-color: rgba(255, 255, 255, 0.5);
  border: 3px solid black;
  width: 100%;
  padding: 6px;
  font-size: 18px;
  font-weight: 800;
  text-align: center;
}

.panel {
  padding: 4rem;
  font-size: 24px;
}
.img-panel {
  padding: 0;
}

.img-1 {
  width: 100%;
}
.img-2 {
  width: 100%;
}

.google-button {
  position: relative;
}
.google-button-overlay {
  pointer-events: none;
  position: absolute;
  left: 4px;
  right: 4px;
  top: 4px;
  bottom: 4px;
  border-radius: 4px;
  transition: background-color 0.15s, box-shadow 0.15s, -webkit-box-shadow 0.15s,
    border 0.15s;
  color: white;
}
.google-button:hover .google-button-overlay {
  -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18),
    0 4px 15px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
}
.google-button:active .google-button-overlay {
  border: 3px rgb(0, 0, 0, 0.2) solid;
}

.loading-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.35);
}

a.clickable {
  transition: opacity 0.15s;
}

a.clickable:hover {
  opacity: 0.6;
}
</style>
